import { bindActionCreators } from 'redux';
import {
  AboutLoaded,
  AdvantagesSliderLoaded,
  AlertLoaded,
  ArticleLoaded,
  BlockedSendLoaded,
  BlogLoaded,
  BlogMainLoaded,
  BlogPopularLoaded,
  CalculatorLoaded,
  HeaderLoaded,
  LogosPartnersLoaded,
  OffsetContentLoaded,
  RecaptchaV2RefLoaded,
  ReviewsLoaded,
  State404Loaded,
  StoriesLoaded,
  VacanciesLoaded,
  WidthWindowLoaded,
  TextCardsLoaded,
  IconCardsLoaded,
  ContactFormsLoaded,
} from '../actions/Actions';

export const MapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      headerLoaded: HeaderLoaded,
      alertLoaded: AlertLoaded,
      storiesLoaded: StoriesLoaded,
      calculatorLoaded: CalculatorLoaded,
      articleLoaded: ArticleLoaded,
      vacanciesLoaded: VacanciesLoaded,
      widthWindowLoaded: WidthWindowLoaded,
      offsetContentLoaded: OffsetContentLoaded,
      blogLoaded: BlogLoaded,
      blogMainLoaded: BlogMainLoaded,
      blogPopularLoaded: BlogPopularLoaded,
      logosPartnersLoaded: LogosPartnersLoaded,
      advantagesSliderLoaded: AdvantagesSliderLoaded,
      reviewsLoaded: ReviewsLoaded,
      aboutLoaded: AboutLoaded,
      state404Loaded: State404Loaded,
      blockedSendLoaded: BlockedSendLoaded,
      recaptchaV2refLoaded: RecaptchaV2RefLoaded,
      textCardsLoaded: TextCardsLoaded,
      iconCardsLoaded: IconCardsLoaded,
      contactFormsLoaded: ContactFormsLoaded,
    },
    dispatch
  );
};
